import { Bars } from 'assets/icons';
import './style.scss';
import { storage } from 'services/config/storage';
import { useTranslation } from "react-i18next"
import { useGameplayConfig } from "store";

const HeroPageTemplate = ({
  heading,
  content,
  companyLogo,
  children,
  headingSize = 40,
  isMobile = false,
  hasGodrejPosition = false
}) => {
  const { t } = useTranslation()
  const { configLanguageSettings } = useGameplayConfig()
  const { isRtlLayout, layoutDirection } = configLanguageSettings;
  const isOrgWhiteLabelled = storage.get.orgInfo()?.organizationConfig?.moduleFlags?.whitelabel;

  const renderLogo = () => {
    return companyLogo ? (
      <div className={`company-logo flex flex-col items-start`}>
        <img src={companyLogo} />
        {
          !isOrgWhiteLabelled &&
          <p className={`color-primary mt-4 flex items-center ${configLanguageSettings.configLanguage !== "en" ? "flex-row-reverse" : "flex-row"}`}>
            {t("powered_by")} <span className="ml-2 mr-2">unberry</span>
          </p>
        }
      </div>
    ) : (
      <>
        {
          !isOrgWhiteLabelled && <h1 className="logo">unberry</h1>
        }
      </>
    );
  };

  return (
    <div className="hero-template-wrapper">
      {isMobile && <div className="mobile-logo-header">{renderLogo()}</div>}
      <div className={`hero-section flex h-full ${hasGodrejPosition ? "godrej-style" : ""}`} dir={layoutDirection}>
        <div>
          {!isMobile && renderLogo()}
          <div className="greetings-form-wrapper">
            <div className="greetings">
              <h1 className={`${!isMobile ? `heading-${headingSize}` : ""}`}>{heading}</h1>
              <p className={""}>{content}</p>
            </div>

            <div>{children}</div>
          </div>
        </div>
        <div>
          <span className={`bars-bg`}>
            <Bars />
          </span>
        </div>
      </div>
    </div>
  );
};

export default HeroPageTemplate;
